import { createAction } from '@reduxjs/toolkit'

/**
 * Replaces the entire results array (sparse — null indicates "still loading"
 * or "failed"). Keeps order index-aligned with the cards rendered by
 * `PhotoshootsRun`.
 */
export const setPhotoshootResults = createAction<(string | null)[]>(
  'photoshoot/setResults',
)

/**
 * Updates a single card slot. Used while results trickle in to avoid
 * re-allocating the entire array.
 */
export const setPhotoshootResultAt = createAction<{ index: number; result: string | null }>(
  'photoshoot/setResultAt',
)

/** Clears all results (run unmount, fresh form, or after a discard). */
export const clearPhotoshootResults = createAction('photoshoot/clearResults')

/**
 * Signal that the run-step component should discard results and return to
 * the form step. Used by the global Navbar back button to talk to the
 * (route-local) run component without a direct prop wiring.
 */
export const requestPhotoshootDiscard = createAction('photoshoot/requestDiscard')

/** Clears the discard signal once the run component has acted on it. */
export const clearPhotoshootDiscardRequest = createAction('photoshoot/clearDiscardRequest')

/**
 * Marks whether the photoshoot run is actively generating results. The global
 * Navbar reads this to disable its Settings button while generation is in
 * flight.
 */
export const setPhotoshootIsGenerating = createAction<boolean>(
  'photoshoot/setIsGenerating',
)

/**
 * Persists the product image the user uploaded on the form step. Lives in the
 * slice (not in `Photoshoots` local state) so it survives a remount of the
 * route-level `Photoshoots` component when the user navigates back from the run
 * step. `null` clears it (explicit remove). Pass a `blob:` URL to set it.
 */
export const setPhotoshootUploadedImage = createAction<string | null>(
  'photoshoot/setUploadedImage',
)
